<div *ngFor="let cl of monsters" class="card mb-3">
    <div class="card-body" *ngFor="let pref of cl.prefixes">
        <h5>{{pref.name}} {{cl.name}} [{{pref.level}}]</h5>
        <app-attribute-store [attributes]="pref.attributes"></app-attribute-store>
    </div>
</div>